import InvitationUrlPopup from './InvitationUrlPopup';

export default InvitationUrlPopup;
